export const aboutTitle = "About";

export const aboutData = (
  <>
    <b>Senior Smart Contract and Protocol Engineer</b> with 5+ years
    designing, building, and securing production blockchain systems —
    including protocols managing <b>$18M TVL</b>,{" "}
    <b>$1.5M in monthly reward distributions</b>, and cross-chain
    infrastructure spanning <b>10 Kadena chains</b>. Deep expertise in{" "}
    <b>Solidity, Foundry, EVM architecture, and DeFi protocols</b>, with a
    strong security background spanning threat modeling, audit preparation,
    fuzz/invariant testing, and incident response to production exploits.
  </>
);
